import type React from 'react';
import './BuiltForCertainty.css';

export default function BuiltForCertainty(): React.JSX.Element {
  return (
    <section className="bfc" aria-labelledby="bfc-heading">
      <div className="bfc__inner">
        <p className="bfc__eyebrow">Execution meets commercial clarity</p>
        <h2 id="bfc-heading" className="bfc__heading">
          Built for certainty in a complex market
        </h2>
        <p className="bfc__body">
          Everfield Group bridges the gap between development and delivery – reducing risk,
          accelerating timelines, and ensuring projects are built to perform in
          real-world grid conditions.
        </p>
      </div>
    </section>
  );
}
